
import {
  computed, defineComponent, PropType,
} from 'vue';

export default defineComponent({
  name: 'SelecionarTipoRelatorioPainelVendas',
  props: {
    codigosSelecionados: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioButton: {
      type: Boolean,
      default: false,
    },
    varios: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (valores: number[] | undefined) => {
        const newValues = valores || [];
        emit('update:codigosSelecionados', newValues);
      },
    });

    function defineValorSelecionado(valores: number[]) {
      emit('update:codigosSelecionados', valores);
      emit('change', valores);
    }

    return {
      props,
      computedCodigosSelecionados,
      defineValorSelecionado,
    };
  },
});
